<template>
  <p class="ld-section-title" :style="`color:${color};margin: ${margin}`">
    <slot>默认标题</slot>
  </p>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#444"
    },
    size: {
      type: Number,
      default: 18
    },
    margin: {
      type: String,
      default: "0"
    }
  }
};
</script>
<style lang="scss" scoped>
.ld-section-title {
  position: relative;
  height: 20px;
  font-size: 18px;
  line-height: 20px;
  text-indent: 11px;
  &:before {
    position: absolute;
    width: 4px;
    top: 0;
    bottom: 0;
    left: 0;
    content: "";
    background-color: #1DA57A;
  }
}
</style>

